import { useEffect } from "react";
import { TextField } from "../../../../utils/form";
import _ from "lodash";

const HealthInsurancePlanInput = ({ form }) => {
  const { control, setValue, watch } = form;
  const healthInsurance = watch("healthInsurance");

  const isParticular = _.lowerCase(healthInsurance) == "particular";

  useEffect(() => {
    if (isParticular) {
      setValue("healthInsurancePlan", "");
    }
  }, [isParticular, setValue]);

  return (
    <TextField
      control={control}
      fullWidth
      name="healthInsurancePlan"
      label="Plan"
      variant="outlined"
      disabled={isParticular}
    />
  );
};

export default HealthInsurancePlanInput;
